module.exports = __webpack_public_path__ + "img/vcontroller-show-dimming1-model.531380ab.jpg";